<template>
   <v-progress-linear
        color="rgb(100, 200, 85)"
		indeterminate
		v-show="isLoading"
      ></v-progress-linear>
</template>

<script>
export default {
	props: {
		isLoading: {
			type: Boolean,
			required: true,
			default: false,
		},
	},
	data() {
		return {

		}
	},
}
</script>

<style>

</style>
